import React from 'react';
import { createStyles, makeStyles, ButtonProps } from '@material-ui/core';
import { t } from 'src/i18n';

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      color: (props: any) => {
        if (props.isDisabled) {
          return '#D8D8D8';
        }

        return '#4c7cfd';
      },
      fontFamily: 'TTCommons',
      fontSize: 15,
      display: 'block',
      background: 'none',
      fontWeight: 600,
      border: 'none',
      margin: 0,
      padding: 0,
      cursor: (props: any) => {
        if (props.isDisabled) {
          return 'initial';
        }

        return 'pointer';
      },
      '&:focus': {
        outline: 0
      }
    }
  })
);

interface IProps extends ButtonProps {
  isDisabled: boolean;
  handleResendOtpCode: any;
}

const ResendOtpButton: React.FC<IProps> = (props) => {
  const classes = useStyles(props);
  const { isDisabled, handleResendOtpCode } = props;

  return (
    <button
      className={classes.button}
      disabled={isDisabled}
      onClick={handleResendOtpCode}
    >
      {t('signIn.otp.resentOTP')}
    </button>
  );
};

export default ResendOtpButton;
